/**
 * Theme-Umschaltung — bewusst statt Auto-Dark (prefers-color-scheme).
 * Default ist das helle Werkstatt-Papier; 'dark'/'blueprint' setzen
 * data-theme auf <html> und werden in localStorage persistiert.
 */
export const THEMES = ['hell', 'dark', 'blueprint'] as const;
export type Theme = (typeof THEMES)[number];

export const THEME_STORAGE_KEY = 'shk-theme';

export function nextTheme(current: Theme): Theme {
  const i = THEMES.indexOf(current);
  return THEMES[(i + 1) % THEMES.length] as Theme;
}

export function loadTheme(storage: Storage | null = globalThis.localStorage ?? null): Theme {
  try {
    const raw = storage?.getItem(THEME_STORAGE_KEY);
    return THEMES.includes(raw as Theme) ? (raw as Theme) : 'hell';
  } catch {
    return 'hell';
  }
}

/** Setzt data-theme auf dem Root-Element ('hell' = Attribut entfernen). */
export function applyTheme(
  theme: Theme,
  root: HTMLElement = document.documentElement,
  storage: Storage | null = globalThis.localStorage ?? null,
): void {
  if (theme === 'hell') delete root.dataset.theme;
  else root.dataset.theme = theme;
  try {
    storage?.setItem(THEME_STORAGE_KEY, theme);
  } catch {
    // Storage voll/blockiert → Theme gilt nur für die Session
  }
}
